<template>
  <div class="menu">
    <router-link :class="{ bold: bold('AdminPhotos') }" :to="{ name: 'AdminPhotos' }">Photos</router-link>
    <router-link :class="{ bold: bold('AdminAnnonces') }" :to="{ name: 'AdminAnnonces' }">Annonces</router-link>
    <router-link :class="{ bold: bold('AdminRestants') }" :to="{ name: 'AdminRestants' }">Restants</router-link>
    <router-link :class="{ bold: bold('AdminUsers') }" :to="{ name: 'AdminUsers' }">Users</router-link>
    <router-link :class="{ bold: bold('AdminVerif') }" :to="{ name: 'AdminVerif' }">Paiements</router-link>
    <router-link :class="{ bold: bold('AdminPromos') }" :to="{ name: 'AdminPromos' }">Promos</router-link>
  </div>
</template>

<script>
export default {
  methods: {
    bold(link) {
      return this.$route.name == link;
    }
  }
};
</script>

<style lang="scss" scoped>
.menu {
  display: grid;
  grid-auto-flow: column;
  grid-gap: 10px;
  padding: 5px;
  justify-content: left;
  justify-items: left;
  border-bottom: 1px dotted #555;
}

.menu a.bold {
  font-weight: bold;
  color: black;
}

.menu a {
  color: #aaa;
}
</style>
